export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9186.da85f6bc.jpg";